import { render, staticRenderFns } from "./Violations.vue?vue&type=template&id=f8cc151e&scoped=true"
import script from "./Violations.vue?vue&type=script&lang=js"
export * from "./Violations.vue?vue&type=script&lang=js"
import style0 from "./Violations.vue?vue&type=style&index=0&id=f8cc151e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cc151e",
  null
  
)

export default component.exports